export const HELP_IS_FETCHING = 'HELP_IS_FETCHING';
export const HELP_IS_SENDED = 'HELP_IS_SENDED';

// Initial State
export const initialState = {
  isFetching: false,
  error: null,
  isSended: false
};

// MOCK VERSION waiting control
export const sendQuestion = question => {
  return dispatch => {
    dispatch({ type: HELP_IS_FETCHING });
    setTimeout(() => {
      dispatch({ type: HELP_IS_SENDED, payload: {}, meta: { ...question } });
    }, 3000);
  };
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case HELP_IS_FETCHING:
      return { ...state, isFetching: true, error: null };

    case HELP_IS_SENDED:
      return { ...state, isFetching: false, error: null, isSended: true };

    case '@@router/LOCATION_CHANGE':
      return { ...state, isSended: false };

    default:
      return { ...state };
  }
};
